import { gql } from '@apollo/client';
import { mutation } from 'services/graphql';
import { surfaceDetailsFragment } from 'graphql/surface/fragments/surface-fragment';

export const markNotificationAsSeenMutation = gql`
  mutation markNotificationAsSeen($id: ID!) {
    markNotificationAsSeen(id: $id) {
      data {
        id
        type
        message
        status
        sender {
          avatar
          firstName
          lastName
          fullName
        }
        surface {
          ...surfaceDetails
        }
      }
      success
      error
    }
  }
  ${surfaceDetailsFragment}
`;

export default mutation(markNotificationAsSeenMutation);
